import React, { useMemo } from 'react';
import { ActivityType, Box, costFormater, Text, useResponsive } from '@common-fe/common-fe';
import styled from 'styled-components';

import ActivityStatus from '@/modules/transaction/components/ActivityStatus';
import { TransactionStatus } from '@/modules/transaction/transaction.types';

import TransactionTitle from './TransactionTitle';

const CLAIM_TRANSFER_TYPE = 'CLAIM_TRANSFER';
const CLAIM_REPAYMENT = 'CLAIM_REPAYMENT';

const StyledRow = styled(Box)`
  &:first-child {
    margin-top: 8px;
  }
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

interface Props {
  category: string;
  type?: string;
  title: string;
  amount: number;
  status: string;
  date: string;
  onPick?: () => void;
}
const TransactionItem: React.FC<Props> = ({ category, title, amount, onPick, date, status, type }) => {
  const { isMobile } = useResponsive();
  const isDeclined = useMemo(() => status === TransactionStatus.Declined, [status]);
  const isPendingStatus = useMemo(() => status === TransactionStatus.Pending, [status]);
  if (isMobile) {
    return (
      <Box margin={{ bottom: 's' }}>
        <Box
          direction="row"
          data-testid="transaction-list-item"
          align="center"
          height={{ min: 'smallItemHeight' }}
          background="canvas"
          round="container1Round"
          pad={{ horizontal: 'm' }}
          border={{ size: 'small', color: 'border2' }}
          onClick={onPick}
        >
          <div data-testid={`activity_type_${type}`}>
            <TransactionTitle
              category={
                type?.startsWith(CLAIM_TRANSFER_TYPE) || type?.startsWith(CLAIM_REPAYMENT)
                  ? ActivityType.CLAIM_TRANSFER_INTERNAL
                  : category
              }
            />
          </div>
          <Box direction="column" justify="center" fill margin={{ left: 's' }}>
            <Text truncate title={title} size="large" weight={400}>
              {title}
            </Text>
            <Text color="textSecondary" size="small" weight={500}>
              {date}
            </Text>
          </Box>
          <Text size="large" weight={700}>
            {costFormater(amount, true)}
          </Text>
          {isPendingStatus && (
            <div>
              <Box margin={{ left: 's' }} width="10px" height="10px" round="50%" background="warning" />
            </div>
          )}
        </Box>
      </Box>
    );
  }
  return (
    <StyledRow>
      <Box
        direction="row"
        data-testid="transaction-list-item"
        align="center"
        height={{ min: 'smallItemHeight' }}
        background="canvas"
        border={{ size: 'small', color: 'border2' }}
        round="container1Round"
        pad={{ horizontal: 'spacing16' }}
        onClick={onPick}
      >
        <Box style={{ flex: 5.3 }} data-testid={`activity_type_${type}`}>
          <TransactionTitle
            category={
              type?.startsWith(CLAIM_TRANSFER_TYPE) || type?.startsWith(CLAIM_REPAYMENT)
                ? ActivityType.CLAIM_TRANSFER_INTERNAL
                : category
            }
          >
            {title}
          </TransactionTitle>
        </Box>
        <Box style={{ flex: 3, minWidth: '170px' }}>
          {status === TransactionStatus.Pending && <ActivityStatus status={status as TransactionStatus} />}
        </Box>
        <Box style={{ flex: 2 }}>
          <Text
            size="large"
            style={{ textDecoration: isDeclined ? 'line-through' : undefined }}
            color={isDeclined ? 'textSecondary' : undefined}
          >
            {costFormater(amount, true)}
          </Text>
        </Box>
        <Box style={{ flex: 0.7 }} align="end">
          <Text size="large" color="textSecondary">
            {date}
          </Text>
        </Box>
        <Box style={{ flex: 0.5 }} /> {/* empty box for spacing */}
      </Box>
    </StyledRow>
  );
};

export default TransactionItem;
